var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { useUpload } from 'apis/uploads';
import { usersApi } from 'apis/users';
import AvatarControl from 'components/shared/avatarControl/components/AvatarControl';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { dataUriToFile } from 'utils/file/dataUriToFile';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useCurrentUser } from 'utils/user/useCurrentUser';
import { profileActions } from '../../../../../../settingsProfile.actions';
import styles from './profileAvatarControl.module.scss';
export const ProfileAvatarControl = () => {
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const { user } = useCurrentUser();
    const [upload, { asyncStatus: uploadAsyncStatus }] = useUpload();
    const [updateUser, { isLoading }] = usersApi.useUpdateUserMutation();
    const handleUpdateUser = useCallback((patch) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { data } = yield updateUser({
                id: user.id,
                patch,
            }).unwrap();
            dispatch(profileActions.update({ user: data }));
            notify({
                title: 'Success',
                text: `Your avatar has been updated.`,
                icon: 'done',
                time: 5000,
            }, NotificationType.Success);
        }
        catch (error) {
            notify({
                title: 'Error while updating the avatar.',
            }, NotificationType.Error);
        }
    }), [dispatch, notify, updateUser, user.id]);
    const handleSelectAvatar = useCallback((dataURI) => __awaiter(void 0, void 0, void 0, function* () {
        const file = yield dataUriToFile(dataURI, 'avatar');
        try {
            const { url } = yield upload({
                file,
                type: 'user_avatar',
            });
            if (url) {
                yield handleUpdateUser({
                    updates: {
                        avatar_url: url,
                    },
                });
            }
        }
        catch (error) {
            notify({
                title: 'Error while updating the avatar.',
            }, NotificationType.Error);
        }
    }), [handleUpdateUser, notify, upload]);
    const handleDeleteAvatar = useCallback(() => {
        handleUpdateUser({
            deletes: ['avatar_url'],
        });
    }, [handleUpdateUser]);
    return (_jsxs(FlexBox, Object.assign({ margin: "0 0 400 0", alignItems: "center", gap: "200" }, { children: [_jsx(AvatarControl, { className: styles.avatarControl, type: "user", user: user, onSelectAvatar: handleSelectAvatar, onDeleteAvatar: handleDeleteAvatar }), (uploadAsyncStatus === 'pending' || isLoading) && _jsx(Spinner, { size: 20 })] })));
};
